import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item1DescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item1Description: React.FC<Item1DescriptionProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [item1, set_item1] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #1']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #1': [v, b.values?.['Expand Primary Structure']?.['Item #1']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={item1}
                />
            ) : (
                <TextBox
                    value={item1}
                    onChange={(value) => set_item1(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
